import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, filter, finalize, map, of, switchMap, take } from 'rxjs';
import {
  DESTINATION_SORT_OPTIONS,
  SERVICE_LEVEL_OPTIONS,
} from 'src/app/SCI/components/shared/add-edit-swap/add-edit-swap.constants';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserAdmin } from 'src/app/core/models/admin/user-admin.model';
import { ShipperConfigBundle } from 'src/app/core/models/sci/shipper-config.model';
import { LocationService } from 'src/app/core/services/admin/location/location.service';
import { UserService } from 'src/app/core/services/admin/user/user.service';
import { ShipperConfigService } from 'src/app/core/services/sci/shipper-config/shipper-config.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { IOption } from '../../shared/form/components/form-select/form-select.model';
import { IMAGE_SRC } from '../../shared/shared-constants';
import { FORM_CONSTANTS, POPUP_LABEL } from '../shipper-config.constants';

@Component({
  selector: 'app-shipper-config-popup',
  templateUrl: './shipper-config-popup.component.html',
  styleUrl: './shipper-config-popup.component.scss',
  standalone: false,
})
export class ShipperConfigPopupComponent implements OnInit {
  readonly destroy = inject(DestroyRef);
  private userService = inject(UserService);

  readonly CONSTANTS = { ...POPUP_LABEL, ...FORM_CONSTANTS };
  readonly IMAGES = IMAGE_SRC;

  shipperConfigForm!: FormGroup;
  timezoneOptionList!: IOption[];
  currentUser!: UserAdmin;
  sortOptions = DESTINATION_SORT_OPTIONS;
  serviceLevelOptions = SERVICE_LEVEL_OPTIONS;

  constructor(
    private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ShipperConfigBundle,
    public readonly dialogRef: MatDialogRef<ShipperConfigPopupComponent>,
    private commonUtils: CommonUtils,
    private locationService: LocationService,
    private shipperConfigService: ShipperConfigService,
  ) {}

  ngOnInit(): void {
    this.setCurrentUser();
    this.initForm(this.data.config);
  }

  initForm(data?: any) {
    this.getAllTimezones();
    this.shipperConfigForm = this._fb.group({
      id: data?.id ?? null,
      version: data?.version ?? null,
      code: data?.code ?? '',
      shipperId: data?.shipperId ?? null,
      origCountry: data?.origCountry ?? '',
      origSlic: data?.origSlic ?? '',
      destMnemonic: data?.destMnemonic ?? '',
      destCountry: data?.destCountry ?? '',
      destSlic: data?.destSlic ?? '',
      pkgLocRole: data?.pkgLocRole ?? '',
      disposition: data?.disposition ?? '',
      pkgCapacity: data?.pkgCapacity ?? '',
      belt: data?.belt ?? '',
      bay: data?.bay ?? '',
      scanUser: data?.scanUser ?? '',
      timeZoneID: data?.timeZoneID ?? null,
      origSort: data?.origSort ?? null,
      destSort: data?.destSort ?? null,
      srvLevel: data?.srvLevel ?? null,
      uldType: data?.uldType ?? '04',
    });
  }

  setCurrentUser() {
    this.userService
      .getCurrentUser$()
      .pipe(
        takeUntilDestroyed(this.destroy),
        filter((user) => !!user),
        switchMap((user) => {
          this.currentUser = user;
          return of(null);
          // return this.getLocationData(user?.locationGroupId || 0);
        }),
        finalize(() => this.commonUtils.updateLoadingModal(false)),
      )
      .subscribe();
  }

  getAllTimezones() {
    this.locationService
      .getAllTimezones()
      .pipe(
        take(1),
        map((data) => {
          this.timezoneOptionList = data?.response.map(
            (timezone: { itemLabel: string; itemValue: string }) => {
              return {
                label: timezone.itemLabel,
                value: timezone.itemValue,
              };
            },
          );
        }),
        catchError(() => {
          // this.commonUtils.updateBannerType(BANNER_TYPE.API_ERROR);
          return of(false);
        }),
      )
      .subscribe();
  }

  onSubmit() {
    this.shipperConfigService
      .addShipperConfig(this.currentUser?.loginId, this.shipperConfigForm.value)
      .subscribe((res) => {
        if (res && res.shipperId) {
          this.close(true);
        }
      });
  }

  close(saved: boolean) {
    this.dialogRef.close({ saved });
  }
}
